
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[pillar]/blog",
      function () {
        return require("private-next-pages/[pillar]/blog/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[pillar]/blog"])
      });
    }
  